import React from "react";
import ReactDOM from "react-dom/client";
import { toast } from "sonner";
import "@/index.css";
import App from "@/App";

// Native alert() is silently suppressed inside the sandboxed preview iframe.
// Route it through a sonner toast so user feedback is never swallowed.
const __nativeAlert = window.alert ? window.alert.bind(window) : () => {};
window.alert = (msg) => {
  try { toast(String(msg), { duration: 6000 }); } catch { __nativeAlert(msg); }
};

// Iter 79 — index.html sniffs for unsupported devices (iPad 3 / iOS ≤ 11,
// IE, old Android stock browser) and sets window.__PHYSIOGENIC_LEGACY__ = true.
// In that case the body has already been replaced with a static fallback;
// we must not mount React over it.
if (!window.__PHYSIOGENIC_LEGACY__) {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
